import type { TranslationKey } from '@/i18n';

export const authStrings = {
  greeting: 'auth.welcome.greeting',
  headline: 'auth.welcome.headline',
  continueWithEmail: 'auth.welcome.continueWithEmail',
  continueWithApple: 'auth.welcome.continueWithApple',
  continueWithGoogle: 'auth.welcome.continueWithGoogle',
  legalAgreement: 'auth.welcome.legalAgreement',
  emailTitle: 'auth.welcome.emailTitle',
  emailDescription: 'auth.welcome.emailDescription',
  emailLabel: 'auth.welcome.emailLabel',
  emailPlaceholder: 'auth.welcome.emailPlaceholder',
  sendCode: 'auth.welcome.sendCode',
  invalidEmail: 'auth.welcome.invalidEmail',
  signInError: 'auth.welcome.signInError',
  signingIn: 'auth.welcome.signingIn',
  appleOnlyOnIosTitle: 'auth.welcome.appleOnlyOnIosTitle',
  appleOnlyOnIosBody: 'auth.welcome.appleOnlyOnIosBody',
  appleUnavailableTitle: 'auth.welcome.appleUnavailableTitle',
  appleUnavailableBody: 'auth.welcome.appleUnavailableBody',
  appleFailedTitle: 'auth.welcome.appleFailedTitle',
  appleMissingTokenBody: 'auth.welcome.appleMissingTokenBody',
  appleFailedBody: 'auth.welcome.appleFailedBody',
  verifyTitle: 'auth.verify.title',
  codeSent: 'auth.verify.codeSent',
  codeLabel: 'auth.verify.codeLabel',
  verify: 'auth.verify.verify',
  missingCodeError: 'auth.verify.missingCodeError',
  invalidCodeError: 'auth.verify.invalidCodeError',
  suspendedError: 'auth.verify.suspendedError',
  resendError: 'auth.verify.resendError',
  didntReceive: 'auth.verify.didntReceive',
  resendCode: 'auth.verify.resendCode',
  resendIn: 'auth.verify.resendIn',
  changeEmail: 'auth.verify.changeEmail',
  // The screen has no idea which email the code was for — see
  // `restorePendingEmail`. It cannot verify anything, so it says so instead of
  // showing a code box that can only ever refuse.
  lostTitle: 'auth.verify.lostTitle',
  lostBody: 'auth.verify.lostBody',
  lostAction: 'auth.verify.lostAction',
  // One sentence per outcome. Every one of these used to read "That code did
  // not work", including the ones where the code was never looked at.
  expiredCodeError: 'auth.verify.expiredCodeError',
  tooManyError: 'auth.verify.tooManyError',
  tooManyAttemptsError: 'auth.verify.tooManyAttemptsError',
  burnedCodeError: 'auth.verify.burnedCodeError',
  codeLengthError: 'auth.verify.codeLengthError',
  serviceError: 'auth.verify.serviceError',
  offlineError: 'auth.verify.offlineError',
  unavailableTitle: 'auth.unavailable.title',
  unavailableBody: 'auth.unavailable.body',
  unavailableSignOut: 'auth.unavailable.signOut',
  tryAgain: 'common.tryAgain',
  back: 'common.back',
} as const satisfies Record<string, TranslationKey>;

/**
 * Authentication entry and email verification copy. "Code" means a one-time
 * verification code. Apple and Google are product names. `legalAgreement`
 * contains link tags and must remain one complete sentence in every locale.
 * Keep opncue lowercase; authentication errors should stay calm and concise.
 */
